import React from 'react';
import './RegisterHeader.css'; // Optional: Import CSS for styling
import { Globals } from '../../global/Globals';
import { useLocation, useNavigate } from 'react-router-dom';

const RegisterHeader = ({onCancelRegister, title, isBackNotRequired}) => {
    
    const location = useLocation();
    const navigate = useNavigate();
    const isCompanyEditPage = location.pathname.includes('edit-company');
    const isProducerEditPage = location.pathname.includes('edit-producer')

    const cancelRegistration=()=>{
        if(onCancelRegister){
            onCancelRegister();
        }
    }
    const handleClick = () => {
          cancelRegistration();
      };
    return (
        <div id="register-heading" className="register-heading">
            <div className="register-heading-content">
                {!isBackNotRequired&&<div id="back" className="back"><img src={Globals.IMG.LEFT_ARROW} alt="back"  onClick={handleClick}/></div>}
                <div id="register-heading-text" className="register-heading-text">{title}</div></div>
            <div id="close-page-cross" className="close-page-cross"><img className="cross-mark" src={Globals.IMG.CLOSE} alt="close" onClick={handleClick}/></div>
        </div>
    );
};

export default RegisterHeader;